import TenDaysMVPQuestions from './TenDaysMVPQuestions';
export default TenDaysMVPQuestions;
